import { Cancel as CancelIcon, DeleteOutline } from "@mui/icons-material";
import { Fragment, useState } from "react";
import { Confirm } from "react-admin";
import ButtonOrMenuItem from "./ButtonOrMenuItem";
import EdmIconButton from "./Buttons/EdmIconButton";

export default function DeleteRelationButton(props) {
  const {
    iconButton = true,
    color = "error",
    confirmContent,
    confirmTitle,
    icon,
    onClick,
    tooltipTitle = null,
    label = null,
    ...rest
  } = props;
  const [confirmIsOpen, setConfirmIsOpen] = useState(false);

  const openConfirm = (e) => {
    e.stopPropagation();
    setConfirmIsOpen(true);
  };
  const closeConfirm = () => setConfirmIsOpen(false);
  const confirm = (e) => {
    onClick?.(e);
    closeConfirm();
  };

  const FinalButton = iconButton ? EdmIconButton : ButtonOrMenuItem;

  let finalTooltipTitle = tooltipTitle;
  if (tooltipTitle === null && iconButton) {
    finalTooltipTitle = "ra.action.delete";
  }

  let finalLabel = label;
  if (label === null && !iconButton) {
    finalLabel = "ra.action.delete";
  }

  return (
    <Fragment>
      <FinalButton
        {...rest}
        label={finalLabel}
        onClick={openConfirm}
        color={color}
        aria-label="remove"
        tooltipTitle={finalTooltipTitle}
        size="medium"
        variant="text"
      >
        {icon ? icon : <DeleteOutline fontSize="inherit" />}
      </FinalButton>

      <Confirm
        isOpen={confirmIsOpen}
        loading={false}
        title={confirmTitle || "ra.message.delete_title"}
        content={confirmContent || "ra.message.delete_content"}
        onConfirm={confirm}
        onClose={closeConfirm}
        CancelIcon={CancelIcon}
      />
    </Fragment>
  );
}
